import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { IdPropType } from '../../../../../proptypes/basic';
import TextInput from '../../../../form/components/TextInput';
import Checkbox from '../../../../form/components/Checkbox';
import EmployeeSelect from '../../../../form/components/specialized/EmployeeSelect';
import ContactSelect from '../../../../form/components/specialized/ContactSelect';
import ContextualCan from '../../../../abilities/components/ContextualCan';
import { READ } from '../../../../abilities/actions';

const AnamnesisSummaryQuestionsContact = ({ name, anamnesisName, customerId, disabled, isFirstQuestionaire}) => (
    <ContextualCan I={READ} field={name}>
        <Grid item md={4}>
            <EmployeeSelect
                name={`${anamnesisName}.meta.employeeRegisteredNurseId`}
                label="Examinierte Pflegekraft"
                filterBy={(employee) => employee.isRegisteredNurse}
                fullWidth
                disabled={disabled}
            />
        </Grid>
        <Grid item md={4}>
            <EmployeeSelect
                name={`${anamnesisName}.meta.employee`}
                label="Anamnese durch"
                filterBy={(employee) => {
                    return employee.locationId;
                }}
                userLocation
                fullWidth
                disabled={disabled}
            />
        </Grid>
        <Grid item md={4}>
            <ContactSelect
                name={`${anamnesisName}.meta.anamnesis.conductedWithName`}
                label="Gesprochen mit"
                customerId={customerId}
                fullWidth
                disabled={disabled}
            />
        </Grid>

        <Grid item md={8}>
            <Checkbox
                name={`${anamnesisName}.meta.anamnesis.ebDiscussedAndAdjusted.value`}
                label="EB wurde mit dem Interessenten in Gänze besprochen und bei Bedarf angepasst"
                disabled={isFirstQuestionaire ? false : disabled}
            />
        </Grid>

        <Grid item md={4}>
            <TextInput
                name={`${anamnesisName}.meta.anamnesis.conductedWithOther`}
                label="Ergänzung"
                fullWidth
                disabled={disabled}
            />
        </Grid>


    </ContextualCan>
);

AnamnesisSummaryQuestionsContact.propTypes = {
    anamnesisName: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    customerId: IdPropType.isRequired,
    disabled: PropTypes.bool,
    isFirstQuestionaire: PropTypes.bool,
};

AnamnesisSummaryQuestionsContact.defaultProps = {
    disabled: false,
    isFirstQuestionaire: false,
};

export default AnamnesisSummaryQuestionsContact;
